const initialState = {
    app: {
        initialized: true
    },
    user: {
        user: false,
        token: ''
    },
    preferences: {
        theme: 'light',
        language: 'en'
    }
};

export default function rootReducer(state = initialState, action) {
    switch (action.type) {
        case 'KEYCLOAK':
            return {
                ...state,
                user: action.payload
            };
        case 'SET_USER':
            return {
                ...state,
                user: {
                    ...state.user,
                    user: action.payload
                }
            };
        case 'SET_TOKEN':
            return {
                ...state,
                user: {
                    ...state.user,
                    token: action.payload
                }
            };
        case 'LOGOUT':
            return {
                ...state,
                user: {
                    user: false,
                    token: ''
                }
            };
        case 'SET_THEME':
        case 'THEME_UPDATE':
            return {
                ...state,
                preferences: {
                    ...state.preferences,
                    theme: action.payload
                }
            };
        case 'SET_LANGUAGE':
        case 'LANGUAGE_UPDATE':
            return {
                ...state,
                preferences: {
                    ...state.preferences,
                    language: action.payload
                }
            };
        default:
            return state;
    }
}
